import { useMemo } from 'react';

const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
  const target = e.target as HTMLElement;
  if (target.tagName !== 'A') return;

  const anchor = target as HTMLAnchorElement;
  const href = anchor.getAttribute('href');
  if (!href?.startsWith('#')) return;

  const id = href.slice(1);
  const element = document.getElementById(id);
  if (element) element.scrollIntoView();
};

export const Content = ({ content }: { content: string }) => {
  return (
    <div
      onClick={handleClick}
      // https://github.com/facebook/react/issues/31660#issuecomment-2585166304
      dangerouslySetInnerHTML={useMemo(() => ({ __html: content }), [content])}
    />
  );
};
